module.exports = __webpack_public_path__ + "img/9.25312b0f.png";